import '../libs/jquery.validate';
import PageComponent from '../base/PageComponent';
import Form from '../components/Form';

export default class SideMenu extends PageComponent {
    init() {
        this.bindButtons();
        this.togglePanel();
        this.bindForm();
    }

    bindButtons() {
        this.addEvent('li', 'mouseover', e => this.onButtonHover(e));
        this.addEvent('li', 'mouseout', e => this.onButtonLeave(e));
    }

    onButtonHover(e) {
        let button = $(e.currentTarget);
        button.addClass('open');
    }

    onButtonLeave(e) {
        let button = $(e.currentTarget);
        button.removeClass('open');
    }

    togglePanel() {
        this.addEvent('.side-menu__form', 'click', e => this.onLinkClick(e));
        this.addEvent('.form__panel .icon-close', 'click', e => this.onCloseClick(e));
    }

    onLinkClick(e) {
        let panel = $('.form__panel');
        let links = $('.side-menu ul');
        links.fadeOut(function(){
            panel.fadeIn();
        });
    }

    onCloseClick(e) {
        let panel = $('.form__panel');
        let links = $('.side-menu ul');
        panel.fadeOut(function () {
            links.fadeIn();
        })
    }

    bindForm() {
        var form = this.childElements('form');
        if(form.length){
            this.form = new Form(form);
            this.form.init();
        }
    }

}



// WEBPACK FOOTER //
// ./javascript/components/SideMenu.js